import React, { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Button from "../../../components/Common/Button";
import { useLocation } from "react-router";
import {
  setImportCurrentView,
  setImportPastBatchResult,
} from "../../Survey/Survey.slice";
import { useDispatch, useSelector } from "react-redux";
import { FormControl } from "@mui/material";
import { formatShortDate, htmlParser } from "../../../Utility/constants";
import { completedPanelImportBatches } from "../../Survey/Survey.service";

const PiPastResults = () => {
  const [selectedBatch, setSelectedBatch] = useState(null);
  const location = useLocation();
  const surveyName = location?.state?.surveyName;
  const surveyPanelId = location?.state?.surveyPanelId;
  const [loadingBatch, setLoadingBatch] = useState(false);
  const personId = useSelector(
    (state) => state?.survey?.loggedInUserData?.authorizedUser?.id
  );
  const selectedBatchId = useSelector((state) => state.survey.selectedBatchId);
  const dispatch = useDispatch();
  const [batchResult, setbatchResult] = useState([]);
  const surveyPanels = useSelector((state) => state.survey.surveyPanels);

  const surveyPanelName = (id) => {
    const panel = surveyPanels.find((panel) => panel.id === id);
    return panel ? panel.name : null;
  };

  useEffect(() => {
    const findCompletedBatches = async () => {
      setLoadingBatch(true);
      try {
        const res = await completedPanelImportBatches(surveyPanelId);
        if (Array.isArray(res?.data) && res?.data?.length > 0) {
          const responseData = res?.data;
          setbatchResult(responseData);
          setSelectedBatch(responseData[0].id);
          setLoadingBatch(false);
        }
      } catch (error) {
        console.error("Error fetching batch Information:", error);
      }
    };
    if (personId) {
      findCompletedBatches();
    }
  }, [personId]);

  useEffect(() => {
    const selectedBatchRecord = async () => {
      try {
        const currentBatch = await batchResult.find(
          (batch) => batch?.id === selectedBatch
        );
        if (currentBatch) {
          await selectedBatchDetails(currentBatch);
        }
      } catch (error) {
        console.error("Error fetching batch Information:", error);
      }
    };
    if (selectedBatch) {
      selectedBatchRecord();
    }
  }, [selectedBatch]);

  const selectedBatchDetails = (currentBatch) => {
    const batchData = {
      batchId: currentBatch["id"],
      fileName: currentBatch["uploadFileName"],
      startDate: currentBatch["dateCreated"],
      recordsUploaded: currentBatch["recordCount"],
      recordExceptions: currentBatch["exceptionsRecordCount"],
      recordValidationErrors: currentBatch["validationRecordCount"],
      uploadedBy: currentBatch["createdBy"],
      recordExceptionDetails: [],
    };
    dispatch(setImportPastBatchResult(batchData));
  };
  return (
    <div>
      <Typography variant="label" color="primary" sx={{ marginBottom: "20px" }}>
        Select Panel Import Batch
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: "20px" }}>
        Functions: select a batch for viewing
      </Typography>
      <Typography variant="label" color="primary" sx={{ marginBottom: "30px" }}>
        Import Panel: {surveyPanelName(surveyPanelId)}
      </Typography>
      <div>
        {loadingBatch && " Loading past batch results..."}
        {batchResult?.length > 0 && (
          <>
            <FormControl
              sx={{ minWidth: 200, marginTop: "10px", marginBottom: "20px" }}
            >
              <Select
                value={selectedBatch}
                onChange={(e) => setSelectedBatch(e.target.value)}
              >
                {batchResult.map((data, index) => (
                  <MenuItem key={index} value={data.id}>
                    Batch ID:{data.id} {formatShortDate(data.dateCreated)} (
                    {data.recordCount} records)
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              <Button
                variant="contained"
                component="label"
                style={{ marginRight: "20px" }}
                onClick={() => dispatch(setImportCurrentView(6))}
              >
                Submit
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => dispatch(setImportCurrentView(1))}
              >
                Back
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PiPastResults;
